import { queryClient } from '../../query-client';
import { sliderKeys } from './query-keys';

/**
 * Invalidates every cached slider feed after a purchase, free claim, or wishlist toggle.
 * Tiles read per-user access flags (hasAccess / aclId / hasAclFree) from the cached payload, so
 * without this a cached feed keeps offering "Buy" for an owned material until staleTime elapses.
 * All feeds are invalidated because the material can appear in any of them.
 */
const invalidateSliderCaches = () => queryClient.invalidateQueries({ queryKey: sliderKeys.all });

export default invalidateSliderCaches;
